/**
 * Centralized API endpoint constants.
 * All Koha REST API paths are defined here to avoid magic strings.
 */
export const API_ENDPOINTS = {
  /** Base path for the Koha REST API (proxied through backend) */
  BASE: '/api/v1',

  /** Bibliographic records */
  BIBLIOS: '/api/v1/biblios',

  /** Libraries/branches */
  LIBRARIES: '/api/v1/libraries',

  /** Items (physical copies) */
  ITEMS: '/api/v1/items',

  /** Patrons (borrowers) */
  PATRONS: '/api/v1/patrons',

  /** Holds (reservations) */
  HOLDS: '/api/v1/holds',

  /** OAuth2 token endpoint (for future use when OAuth2 is enabled) */
  OAUTH_TOKEN: '/api/v1/oauth/token',

  /**
   * Build a cover image URL for a specific biblio.
   * Koha serves cover images at: /api/v1/public/biblios/{id}/cover_images/{imageId}
   */
  coverImage: (biblioId: number, imageId: number): string =>
    `/api/v1/public/biblios/${biblioId}/cover_images/${imageId}`,
} as const;

